import { type RouteRecordRaw } from 'vue-router'

import { AiDocumentProcessorPage } from 'src/CrudManager/Core/pages'
import { useUserStore } from 'src/CrudManager/Core/stores/useUserStore'

const routes: RouteRecordRaw[] = [
  {
    path: '/manage/:modelSlug?/:moduleSlug?/:modelId?',
    name: 'crudmanager',
    component: () => import('src/CrudManager/Core/composites/Layout/CrudManager.vue'),
  },
  {
    path: '/ai-document-processor',
    name: 'ai-document-processor',
    component: AiDocumentProcessorPage,
    meta: {
      title: 'AI Document Processor',
      description: 'Upload and process documents with AI-powered data extraction',
      requiresAuth: true,
    },
    beforeEnter: () => {
      const userStore = useUserStore()

      if (userStore.currentUserCan('ai.dashboard')) {
        return true
      }

      console.log('User does not have permission to access AI Document Processor')
      return '/'
    },
  },
]

export default routes
